var exports = {
  "zr": "x1cb7f6e3--1852dd--root",
  "wm": "x1cb7f6e3--1852dd--logo",
  "UU": "x1cb7f6e3--1852dd--name",
  "_A": "x1cb7f6e3--1852dd--tags",
  "Tc": "x1cb7f6e3--1852dd--tag",
};

module.exports = exports;
